<div class="dContainer">
  <div class="dHeader">
    DRAFT STARTING
  </div>
  <div class="dBody">
    <span class="title">{{league.league_name}}</span> is starting in {{formatTime(league.remaining_time)}}
  </div>
  <div class="dActions">
    <a [routerLink]="'draft/'+league.league_id" (click)="close()" mat-stroked-button>DRAFT</a>
    <button mat-stroked-button (click)="close()">CLOSE</button>
  </div>
</div>